<main>
    <div class="cont-sup">
      <h5 class="title">Comprobantes proveedor</h5>
      <button mat-icon-button color="primary" aria-label="button with a mail icon" matTooltip="Enviar consulta por mail" matTooltipPosition="left" routerLink="/home/mailing/cli">
        <mat-icon>mail</mat-icon>
  
      </button>
    </div>
      <div class="cards">
        <div>
          <mat-form-field appearance="fill">
            <mat-label>Fecha desde</mat-label>
            <input matInput [matDatepicker]="picker1" [value]="fecha_desde_moment" (dateChange)="dateChanged($event)">
            <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </div>
        <div >
          <mat-form-field appearance="fill">
            <mat-label>Fecha hasta</mat-label>
            <input matInput [matDatepicker]="picker2" [value]="fecha_hasta_moment" (dateChange)="dateChanged2($event)">
            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </div>
        <div >
          <mat-form-field appearance="fill">
            <mat-label>Estado</mat-label>
            <mat-select name="estado" [(value)]="estado">
              <mat-option value="{{estado.id}}" (click)="setEstado()" *ngFor="let estado of estados">{{estado.descrip}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="card-single">
            <!-- <span class="flex"><span class="total-span totales">Total</span> <span class="to-right">${{total | number: '.2'}}</span></span> -->
            <span class="flex"><span class="totales">Total Pendiente</span> <span class="to-right">${{total_pendiente | number: '.2'}}</span></span>
        </div>
  
      </div>
  
  
      <div class="recent-grid">
        <div class="example-loading-shade"
        *ngIf="isLoadingResults">
          <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
        </div>
        <div class="img-nf" *ngIf="!estaVacio">
            <img src="assets/img/notFound.svg" alt="">
            <h5>Ups! No existen datos para la consulta</h5>
        </div>
        <div class="mat-elevation-z8 example-table-container" *ngIf="estaVacio">
  
          <table mat-table [dataSource]="dataSource"  >
  
              <!-- Position Column -->
              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef> Estado </th>
                <td mat-cell *matCellDef="let comp" [ngClass]="{'color-vencido': comp.comp_vencido=='S'}" > {{comp.estado}} </td>
              </ng-container>
  
              <!-- Name Column -->
              <ng-container matColumnDef="descrip">
                <th mat-header-cell *matHeaderCellDef style="text-align: start;"> Comprobante </th>
                <td mat-cell *matCellDef="let comp" style="text-align: start;" [ngClass]="{'color-vencido': comp.comp_vencido=='S'}"> {{comp.descrip_comp}} </td>
              </ng-container>

              <ng-container matColumnDef="sucur">
                <th mat-header-cell *matHeaderCellDef> Sucursal </th>
                <td mat-cell *matCellDef="let comp" style="text-align: start;" [ngClass]="{'color-vencido': comp.comp_vencido=='S'}"> {{comp.sucur}} </td>
              </ng-container>
  
              <ng-container matColumnDef="num">
                <th mat-header-cell *matHeaderCellDef> Nro. </th>
                <td mat-cell *matCellDef="let comp" style="text-align: start;" [ngClass]="{'color-vencido': comp.comp_vencido=='S'}"> {{comp.num}} </td>
              </ng-container>
              <!-- Weight Column -->
              <!-- <ng-container matColumnDef="num">
                <th mat-header-cell *matHeaderCellDef> Nro. </th>
                <td mat-cell *matCellDef="let comp"> {{comp.num}} </td>
              </ng-container> -->
  
              <!-- Symbol Column -->
              <ng-container matColumnDef="fecha">
                <th mat-header-cell *matHeaderCellDef> Fecha </th>
                <td mat-cell *matCellDef="let comp" class="num" [ngClass]="{'color-vencido': comp.comp_vencido=='S'}"> {{comp.fecha|date:'dd/MM/yyyy'}} </td>
              </ng-container>
  
              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef> Total </th>
                <td mat-cell *matCellDef="let comp" class="num" [ngClass]="{'color-vencido': comp.comp_vencido=='S'}"> {{comp.mone=='PES'?'$':comp.mone}} {{comp.total | number: '.2'}} </td>
              </ng-container>
  
              <ng-container matColumnDef="saldo">
                <th mat-header-cell *matHeaderCellDef> Saldo </th>
                <td mat-cell *matCellDef="let comp" class="num" [ngClass]="{'color-vencido': comp.comp_vencido=='S'}">{{comp.saldo * comp.mone_coti | number: '.2'}} </td>
              </ng-container>
  
              <ng-container matColumnDef="fecha_vencimiento">
                <th mat-header-cell *matHeaderCellDef> Venc. </th>
                <td mat-cell *matCellDef="let comp" class="num" [ngClass]="{'color-vencido': comp.comp_vencido=='S'}"> {{comp.vencimiento |date:'dd/MM/yyyy'}}
                  <div class="vencido color-vencido">{{comp.comp_vencido=='S'?'VENCIDO':''}}</div>
                </td>
              </ng-container>

  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
  
          </div>
        </div>
        <mat-paginator *ngIf="estaVacio" [pageSizeOptions]="[15]"
                       showFirstLastButtons
                       aria-label="Select page of periodic elements">
        </mat-paginator>
    </main>
  